import { Operation } from '../../../__generated__/globalTypes'

import {
  InviteFragment,
  inviteFragmentString,
} from '../../fragments/__generated__/InviteFragment'

import { calendarDateFragmentString } from '../../fragments/__generated__/CalendarDateFragment'

import { detailedContactFragmentString } from '../../fragments/__generated__/DetailedContactFragment'

import { noteFragmentString } from '../../fragments/__generated__/NoteFragment'

import { addressFragmentString } from '../../fragments/__generated__/AddressFragment'

import { relatedContactFragmentString } from '../../fragments/__generated__/RelatedContactFragment'

import { socProContactFragmentString } from '../../fragments/__generated__/SocProContactFragment'

import { contactFragmentString } from '../../fragments/__generated__/ContactFragment'

import { optionalYearDateFragmentString } from '../../fragments/__generated__/OptionalYearDateFragment'

import { prospectFragmentString } from '../../fragments/__generated__/ProspectFragment'

import getPaginatedInvitesRawString from '../GetPaginatedInvites.graphql'

const getPaginatedInvitesString = [
  getPaginatedInvitesRawString,
  inviteFragmentString,
  calendarDateFragmentString,
  detailedContactFragmentString,
  noteFragmentString,
  addressFragmentString,
  relatedContactFragmentString,
  socProContactFragmentString,
  contactFragmentString,
  optionalYearDateFragmentString,
  prospectFragmentString,
].join('\n\n')

export type GetPaginatedInvitesData = {
  paginatedInvites: {
    results: InviteFragment[]
    count: number
  }
}

export type GetPaginatedInvitesVariables = {
  offset: number
  limit: number
}

export type GetPaginatedInvites = Operation<
  GetPaginatedInvitesData,
  GetPaginatedInvitesVariables
>

export const GetPaginatedInvites = ({
  offset,
  limit,
}: GetPaginatedInvitesVariables): GetPaginatedInvites => ({
  query: getPaginatedInvitesString,
  variables: {
    offset,
    limit,
  },
})
